export const fieldsearchdata = [
    { name: "Tous les champs", id: "all" },
    { name: "Nom", id: "name" },
    { name: "Adresse", id: "address" },
    { name: "Pdl", id: "pdl" },
  ];
  